export { default as GenNavTile } from './GenNavTile';
